import * as types from "./types";

function ponerColegioSeleccionado(payload) {
  return { type: types.COLEGIO_SELECCIONADO, payload };
}

function limpiarColegioSeleccionado() {
  return { type: types.RESET_COLEGIO_SELECCIONADO };
}

function detalleColegio(payload) {
  return { type: types.DETALLE_COLEGIO, payload };
}

function resetDetalleColegio() {
  return { type: types.RESET_DETALLE_COLEGIO };
}

function listaResguardos(payload) {
  return { type: types.LISTA_RESGUARDOS, payload };
}

function resetListaResguardos() {
  return { type: types.RESET_LISTA_RESGUARDOS };
}

function procesoEnvio(payload) {
  return { type: types.PROCESO_ENVIO, payload };
}

function resetProcesoEnvio() {
  return { type: types.RESET_PROCESO_ENVIO };
}

function uploadComplete(payload) {
  return { type: types.UPLOAD_COMPLETE, payload };
}

function clearUploadComplete(payload) {
  return { type: types.CLEAR_UPLOAD_COMPLETE };
}

/*---*/
export {
  ponerColegioSeleccionado,
  limpiarColegioSeleccionado,
  detalleColegio,
  resetDetalleColegio,
  listaResguardos,
  resetListaResguardos,
  procesoEnvio,
  resetProcesoEnvio,
  uploadComplete,
  clearUploadComplete
};



// WEBPACK FOOTER //
// ./src/ducks/documentacion/actions.js